import { Consent, LoanApplication, getBrowserFingerprintData, BrowserConsentMetadata } from "@oneethos/shared"
import { ConsumerAppFormData } from "../pages/consumerApplicationForm"
import { ReactNode } from "react"

type AgreementCheckboxProps = {
  formData: ConsumerAppFormData
  update: (data: string | Partial<LoanApplication>, value?: BrowserConsentMetadata | boolean) => void
  name: string
  children: ReactNode
}

export const AgreementCheckbox = ({
  formData,
  update,
  name,
  children
}: AgreementCheckboxProps) => {
  return <div className="form-group">
    <label className="d-flex align-items-start gap-2" style={{ cursor: 'pointer' }}>
      <input type="checkbox"
        onChange={ev => {
          update(name, ev.target.checked ? {
            browser: getBrowserFingerprintData(),
            timestamp: new Date(),
            agrees: true
          } : false)
        }}
        checked={formData[name]?.agrees || false}
      />
      <div>
        {children}
      </div>
    </label>
  </div>
}

export default AgreementCheckbox
